export default {
  name: 'ModalConfimarSemAdiantamento'
}



// WEBPACK FOOTER //
// ./src/views/private/travelreimbursement/components/ModalConfimarSemAdiantamento/ModalConfimarSemAdiantamento.js